import { AdvisingAbnormalOperationUserBean } from './advising-abnormal-operation-user-bean';
export class AdvisingAbnormalMailRequest extends AdvisingAbnormalOperationUserBean {
  adNos: string[];
  facilities: string[];

  constructor() {
    super()
    this.adNos = [];
    this.facilities = [];
  }
}
